/**
 * Suspense fallback for lazily loaded routes.
 *
 * Rendered inside <Layout> (below the nav) so the header, nav and footer stay
 * mounted while a route chunk is fetched. App.tsx also uses it for the routes
 * that sit outside Layout.
 */
export const RouteLoader = () => (
  <div className="flex items-center justify-center min-h-[50vh]">
    <div className="loading loading-spinner loading-lg text-primary" />
  </div>
);

export default RouteLoader;
